import React from "react";
import { Component } from "react";
import { RequestHeaders } from "../../../common/header-logo/request-header.component";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../utils/helpers.utils";
import DetailContainer from "../../../common/Layout/details/DetailsLayout.component";
import { Selected_Index } from '../../../../constants/external-constants';
import DebitorCatalogueTable from "./debitor-catalogue-table/debitor-catalogue-table.component";
import ModalContainer from "../../../common/modal/modal-container/modal-container.component";
import DebitorUpload from "./debitor-upload/debitor-upload.component";
class DebitorCatalogue extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: Selected_Index.i_Zero,
            contentIndex:  Selected_Index.i_Zero        
        }
    }
   
    handleSelectedIndex = (index) =>{
        this.setState({contentIndex: index})      
    }
    render() {
               
        const { contentIndex } = this.state

        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingDebitorCatalogueDashboardRW])

        return(
            <div className="rate-card-container invoice-wrapper-container inventory-report-component" >
                <RequestHeaders headerTitle={'DebitorCatalogue'} />                
                <div className="request-table data-table fit-width">
                    <DetailContainer
                        renderTabContent={this.handleSelectedIndex}
                        urlIndex={this.state.activeTab}
                        listTab={ [
                            {
                                "id": Selected_Index.i_Zero,
                                "label": "Debitor List",
                                "hidden": false
                            },
                            {
                                "id": Selected_Index.i_One,
                                "label": "Debitor Upload",
                                "hidden": (isReadOnly || (!isReadAndExtractOnly && !isReadAndWrite)) ? true : false,
                                "disable": false
                            },
                            
                        ]}
                    >
                        
                    {contentIndex === Selected_Index.i_Zero && <DebitorCatalogueTable />}
                    {contentIndex === Selected_Index.i_One && <DebitorUpload />}
                    </DetailContainer>
                </div>    
            </div>
        )
    }
}

export default DebitorCatalogue;